(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement-message"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-coupon-code]');
    if (!button) return;

    const code = button.dataset.couponCode;
    const status = button.parentElement.querySelector('[data-coupon-status]');

    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      const input = document.createElement('textarea');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }

    button.classList.add('is-copied');
    if (status) status.textContent = button.querySelector('.announcement-coupon__copied').textContent;

    clearTimeout(button.copiedTimeout);
    button.copiedTimeout = setTimeout(() => {
      button.classList.remove('is-copied');
      if (status) status.textContent = '';
    }, 2000);
  });
  } catch(e) { console.error(e); }
})();

})();
